import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Contact from "@/pages/Contact";
import BillingSuccess from "@/pages/BillingSuccess";
import BillingCancel from "@/pages/BillingCancel";
import Dashboard from "@/pages/Dashboard";
import CompetitionsList from "@/pages/CompetitionsList";
import CompetitionView from "@/pages/CompetitionView";
import Profile from "@/pages/Profile";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCompetition from "@/pages/AdminCompetition";
import SuperAdmin from "@/pages/SuperAdmin";

function Shelled({ children }) {
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ForgotPassword />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
            <Route path="/app/dashboard" element={<ProtectedRoute><Shelled><Dashboard /></Shelled></ProtectedRoute>} />
            <Route path="/app/competitions" element={<ProtectedRoute><Shelled><CompetitionsList /></Shelled></ProtectedRoute>} />
            <Route path="/app/competitions/:id" element={<ProtectedRoute><Shelled><CompetitionView /></Shelled></ProtectedRoute>} />
            <Route path="/app/profile" element={<ProtectedRoute><Shelled><Profile /></Shelled></ProtectedRoute>} />

            <Route path="/app/admin" element={<ProtectedRoute roles={["competition_admin", "super_admin"]}><Shelled><AdminDashboard /></Shelled></ProtectedRoute>} />
            <Route path="/app/admin/competitions/:id" element={<ProtectedRoute roles={["competition_admin", "super_admin"]}><Shelled><AdminCompetition /></Shelled></ProtectedRoute>} />

            <Route path="/app/super-admin" element={<ProtectedRoute roles={["super_admin"]}><Shelled><SuperAdmin /></Shelled></ProtectedRoute>} />

            <Route path="/app/billing/success" element={<ProtectedRoute><Shelled><BillingSuccess /></Shelled></ProtectedRoute>} />
            <Route path="/app/billing/cancel" element={<ProtectedRoute><Shelled><BillingCancel /></Shelled></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors closeButton position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
